import { COMPLIANCE_BADGES } from '@/config/constants';
import FeatureIcon from '@/components/ui/FeatureIcon';

export default function ComplianceBadges() {
  return (
    <section className="section-padding bg-secondary-50 dark:bg-secondary-800">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-white mb-4">
            Security & Compliance First
          </h2>
          <p className="text-lg text-secondary-600 dark:text-secondary-400">
            Built to meet Australian healthcare and privacy standards from day one.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {COMPLIANCE_BADGES.map((badge) => (
            <div
              key={badge.name}
              className="card p-6 text-center hover:shadow-soft-lg transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-success-50 dark:bg-success-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="text-success-700 dark:text-success-200">
                  <FeatureIcon name={badge.icon} className="w-8 h-8" />
                </div>
              </div>
              <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                {badge.name}
              </h3>
              <p className="text-sm text-secondary-600 dark:text-secondary-400">
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

